module.exports = __webpack_public_path__ + "img/converted.0e66732b.svg";